<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-30 18:10:11
 * @LastEditTime: 2021-03-03 10:58:00
-->
<template>
  <div id="group">
    <div class="ci-problem">
      <p>分组<span>(将用户进行分组)</span></p>
      <p style="font-size: 14px">
        当前分组:<span style="color: #409eff">{{ curGroupName }}</span>
      </p>
      <div>
        <el-button type="success" round @click="groupVisib = true"
          >加入分组
          <i class="el-icon-folder-add"></i>
        </el-button>
      </div>
    </div>

    <el-dialog title="分组操作" :visible.sync="groupVisib" width="40%">
      <el-select
        v-model="value"
        filterable
        allow-create
        default-first-option
        placeholder="请选择分组,可随时创建分组名"
        style="width: 300px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupVisib = false">取 消</el-button>
        <el-button type="primary" @click="groupSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateSug } from "@/api/chat";
import { option } from "runjs";
export default {
  props: ["curUserId", "curUserName", "curPkg"],
  data() {
    return {
      groupVisib: false,
      options: [],
      value: "",
      info: {},
      curGroupName: "",
    };
  },
  watch: {
    curUserId() {
      this.getCurGroup();
    },
  },
  mounted() {
    let info = JSON.parse(localStorage.getItem("u_g"));

    let optionList = [];
    for (let key in info) {
      optionList.push({
        value: key,
        label: key,
      });
    }
    this.options = optionList;

    this.info = info || {};
  },
  methods: {
    getCurGroup() {
      let _name = [];
      for (let key in this.info) {
        this.info[key].forEach((item) => {
          if (item.pk == this.curUserId) {
            _name.push(key);
          }
        });
      }
      this.curGroupName = _name.join(",");
    },
    groupSure() {
      if (this.value in this.info) {
        let ids = [];
        this.info[this.value].forEach((item) => {
          ids.push(item.pk);
        });
        if (ids.indexOf(this.curUserId) === -1) {
          this.info[this.value].push({
            pk: this.curUserId,
            u_name: this.curUserName,
            pkg: this.curPkg,
          });
        }
      } else {
        this.info[this.value] = [];
        this.info[this.value].push({
          pk: this.curUserId,
          u_name: this.curUserName,
          pkg: this.curPkg,
        });
      }

      let vlList = [];
      this.options.forEach((item) => {
        vlList.push(item.value);
      });
      if (vlList.indexOf(this.value) === -1) {
        this.options.push({
          value: this.value,
          label: this.value,
        });
      }

      let params = {
        info: this.info,
      };
      updateSug(params).then((res) => {
        localStorage.setItem("u_g", JSON.stringify(this.info));
        this.$message({
          message: "加入分组成功",
          type: "success",
        });
        // this.info = {};
        this.getCurGroup();
      });
      this.groupVisib = false;
      this.value = "";
    },
  },
};
</script>

<style lang="scss" scoped>
#order {
  width: 100%;
  height: 100%;
}
.ci-problem {
  padding: 0 20px 40px;
  p {
    margin: 0 0 15px;
    color: #333333;
    font-size: 16px;
  }
  span {
    margin-left: 10px;
    color: #8d8d8d;
    font-size: 12px;
  }
}
</style>